import {
  HEALTH_CHALLENGES_BASE_ROUTE,
  HEALTH_CHALLENGES_SECURE_BASE_ROUTE,
  NEURODIVERSITY_BASE_ROUTE,
  NEURODIVERSITY_SECURE_BASE_ROUTE,
} from '@lyrahealth-inc/shared-app-logic'

export function isPathInNeurodiversityFlow(pathname: string) {
  return pathname.startsWith(NEURODIVERSITY_BASE_ROUTE) || pathname.startsWith(NEURODIVERSITY_SECURE_BASE_ROUTE)
}

export function isPathInHealthChallengesFlow(pathname: string) {
  return pathname.startsWith(HEALTH_CHALLENGES_BASE_ROUTE) || pathname.startsWith(HEALTH_CHALLENGES_SECURE_BASE_ROUTE)
}
